<template>
  <div class="van-dialog">
    <el-dialog :visible.sync="show"
               :show-close="showClose"
               width="960px" top="10vh"
               :showClose="!isDisableClose"
               :close-on-click-modal="!isDisableClose"
               :close-on-press-escape="!isDisableClose"
               :class="{ 'eyeshield-color': isOpenEyeshield }">
      <div class="dialog-title" slot="title">
        <slot name="title"></slot>
        <div
          class="eyeshield"
          v-if="show">
          <el-switch
            v-model="isOpenEyeshield"
            inactive-text="护眼模式" />
        </div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="dialog-footer"
           v-if="isShowFooter"
           slot="footer">
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Switch } from 'element-ui';
import utils from '@/services/utils';

export default {
  components: {
    ElDialog: Dialog,
    ElSwitch: Switch,
  },
  props: {
    showClose: {
      type: Boolean,
      default: true,
    },
    skin: {
      type: String,
      default: '',
    },
    isDisableClose: {
      type: Boolean,
      default: false,
    },
    isShowFooter: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isOpenEyeshield() {
      if (this.isOpenEyeshield) {
        utils.storage('isOpenEyeshield', 1);
      } else {
        utils.storage('isOpenEyeshield', 0);
      }
    },
  },
  data() {
    return {
      show: false,
      isOpenEyeshield: false,
    };
  },
  created() {
    this.isOpenEyeshield = !!utils.storage('isOpenEyeshield');
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';

  .van-dialog {
    .el-dialog {
      box-sizing: border-box;
      max-height: 628px;
      .dialog-title {
        position: relative;
        overflow: hidden;
      }
      .el-dialog__header {
        font-size: 18px;
        padding: 0;
        .title {
          height: 45px;
          line-height: 45px;
          padding: 0 20px;
          margin: 0;
          background-color: $gray-bg-color;
        }
        .el-dialog__headerbtn {
          top: 15px;
        }
        .el-progress-bar {
          display: block;
        }
      }
      .el-dialog__footer {
        border-top: 1px solid $gray-bg-color;
        padding: 15px 20px;
      }
      .el-dialog__body {
        padding: 0;
        .content {
          position: relative;
          padding: 20px;
        }
      }
    }
    .eyeshield-color {
      .el-dialog {
        background: rgb(233, 235, 254)!important;
        .hydc-container {
          .word-wrap {
            li {
              background: rgb(233, 235, 254) !important;
            }
          }

          .answer-wrap {
            background: rgb(233, 235, 254) !important;
          }
        }

        .dcpx-container {
          .letter-input {
            background: rgb(233, 235, 254) !important;
          }
        }

        .dctx-container {
          .text-input {
            background: rgb(233, 235, 254) !important;
          }
        }

        .bs-wrapper {
          .main {
            .sentence-wrapper {
              .sentence-container {
                .sentence {
                  display: inline-block;
                  margin: 5px 2px;
                  border-bottom: 1px #333 solid;
                  background: #e9ebfc -webkit-linear-gradient(left, black, black) no-repeat 0 0;
                  background-size: 0 100%;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  font-size: 24px;
                  text-align: center;
                  line-height: 1.5;
                  transition: background-size .5s linear;
                }

                .show {
                  background-size: 100% 100%;
                }
              }
            }
          }
        }
      }
      .dialog-title, .content {
        background: rgb(233, 235, 254)!important;
        .control-bar {
          background: rgb(233, 235, 254)!important;
        }
        .answer-card {
          background: rgb(233, 235, 254)!important;
        }
        .game-control-bar {
          border-bottom: rgb(233, 235, 254)!important;
        }
        /deep/ .el-progress  {
          background: rgb(233, 235, 254)!important;
        }
      }
    }
    .eyeshield {
      position: absolute;
      top: 16px;
      right: 120px;
      z-index: 9999;
    }
  }
  .hk-dialog {
    .eyeshield-color {
      .el-dialog__footer {
        background: rgb(233, 235, 254)!important;
      }
    }
  }
  .chapter {
    .eyeshield-color {
      .aside {
        border: 1px solid #fff!important;
      }
      .shadow-box {
        border: 1px solid #fff!important;
      }
    }
  }
</style>
